import React, { useState, useEffect } from "react";
import { db, auth } from "../../utils/Firebase-Config"; // Imported auth instance
import {
  collection,
  addDoc,
  onSnapshot,
  doc,
  setDoc,
  arrayUnion,
} from "firebase/firestore";
import "./Dashboard.css";
import CreatePortfolio from "./CreatePortfolio";
import GalleryUpload from "./GalleryUpload";
import RadarIcon from "@mui/icons-material/Radar";
import SecurityIcon from "@mui/icons-material/Security";
import PaletteIcon from "@mui/icons-material/Palette";
import { UserAuth } from "../../utils/AuthContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EvidenceUploader from "./EvidenceDownloader";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';

export default function Dashboard() {
  const { user } = UserAuth();

  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeSiteId, setActiveSiteId] = useState(
    localStorage.getItem("savedSiteId") || null
  );
  const [botLogs, setBotLogs] = useState([]);
  const [activeApiKey, setActiveApiKey] = useState("");

  const [dashboardTab, setDashboardTab] = useState("radar");
  const [activeTab, setActiveTab] = useState("static");

  const [rawUrls, setRawUrls] = useState("");

  const obfuscateUrl = (plainUrl) => {
    if (!plainUrl || !plainUrl.trim()) return "";
    const reversed = plainUrl.trim().split("").reverse().join("");
    return btoa(reversed);
  };

  const generateEmbedSnippet = (apiKey) => {
    return `<script data-api-key="${apiKey}">
(function(){
  let tdmLink = document.querySelector('link[rel="tdm-reservation"]');
  if (!tdmLink) {
    tdmLink = document.createElement('link');
    tdmLink.rel = 'tdm-reservation';
    tdmLink.href = 'https://w3c.github.io/tdm-rep/samples/policy-reserved.json';
    document.head.appendChild(tdmLink);
  }
  const tags = [
    {name:"robots",content:"noarchive, noimageindex, nosnippet"},
    {name:"ai-exclusion",content:"true"},
    {name:"noai",content:"true"},
    {name:"noimageai",content:"true"}
  ];
  tags.forEach(e=>{
    let n=document.querySelector(\`meta[name="\${e.name}"]\`);
    n||(n=document.createElement("meta"),n.name=e.name,document.head.appendChild(n)),n.content=e.content
  });
  const e=navigator.userAgent; let n=null;
  if(e.includes("GPTBot")?n={name:"OpenAI (GPTBot)",type:"Model Training",reason:"Ingesting portfolio images to train future generative visual models like DALL-E."}:e.includes("OAI-SearchBot")?n={name:"OpenAI Search",type:"Real-Time Indexing",reason:"Scanning images to display them directly as conversational search results inside ChatGPT."}:e.includes("ChatGPT-User")?n={name:"ChatGPT User Fetch",type:"Direct User Prompt",reason:"An active user pasted your URL directly into a prompt window, requesting ChatGPT analyze the page content."}:e.includes("Claude-User")?n={name:"Claude User Fetch",type:"Direct User Prompt",reason:"An active user pasted your URL directly into Claude, requesting the assistant analyze the page content."}:e.includes("Claude-SearchBot")?n={name:"Claude Search",type:"Real-Time Indexing",reason:"Scanning layout properties to populate the retrieval layers behind conversational search answers."}:e.includes("ClaudeBot")||e.includes("anthropic-ai")?n={name:"Anthropic Claude",type:"Model Training",reason:"Harvesting style arrays and creative imagery to refine Claude multimodal neural structures."}:e.includes("Google-Extended")||e.includes("Googlebot")?n={name:"Google Gemini Engine",type:"Model Training",reason:"Extracting portfolio layouts to populate Gemini structural generative image weights."}:e.includes("Applebot-Extended")?n={name:"Apple Intelligence",type:"Model Training",reason:"Indexing art samples to train on-device generative software across Apple ecosystems."}:e.includes("Perplexity-User")?n={name:"Perplexity User Fetch",type:"Direct User Prompt",reason:"An active user pasted your URL directly into a prompt window, requesting Perplexity analyze the page content."}:e.includes("PerplexityBot")?n={name:"Perplexity AI",type:"Real-Time Indexing",reason:"Scraping live structural properties to display references within conversational search cards."}:e.includes("meta-externalfetcher")?n={name:"Meta AI Fetcher",type:"Real-Time Indexing",reason:"Scanning live structural properties to display references or answers within Meta AI conversational features."}:e.includes("meta-externalagent")||e.includes("facebookexternalhit")?n={name:"Meta AI",type:"Model Training",reason:"Infiltrating art sites to optimize text-to-image engines across Instagram, WhatsApp, and Facebook features."}:e.includes("Amazonbot")?n={name:"Amazon Bot",type:"Model Training",reason:"Scanning layout properties to improve Alexa answer capabilities and train Amazon retail AI models."}:e.includes("cohere-ai")?n={name:"Cohere Bot",type:"Model Training",reason:"Harvesting style arrays and web elements to train enterprise Cohere LLM weights."}:e.includes("YouBot")?n={name:"YouBot AI",type:"Real-Time Indexing",reason:"Scanning live properties to index and reference within You.com conversational search queries."}:e.includes("CCBot")?n={name:"Common Crawl Bot",type:"Mass Ingestion Data Broker",reason:"Copying open web elements to compile massive public datasets, heavily abused by unregulated AI training labs."}:e.includes("Bytespider")&&(n={name:"ByteDance AI",type:"Mass Ingestion",reason:"Harvesting raw media assets for TikTok parent organization AI tools and video diffusion frameworks."}),n){
    const currentScript = document.currentScript;
    const o = currentScript ? currentScript.getAttribute("data-api-key") : null;
    if(o){
      const dbUrl = "https://logbot-sl5e5lb5lq-uc.a.run.app";
      const c = JSON.stringify({
        botName: n.name,
        botType: n.type,
        botReason: n.reason,
        pageUrl: window.location.href
      });
      fetch(dbUrl, { 
        method: "POST", 
        body: c, 
        headers: { 
          "Content-Type": "application/json",
          "X-Mvelio-API-Key": o 
        } 
      });
    }
  } else {
    const isStealthScraper = navigator.webdriver || (window.innerWidth === 0 && window.innerHeight === 0) || (!navigator.languages || navigator.languages.length === 0);
    const currentScript = document.currentScript;
    const o = currentScript ? currentScript.getAttribute("data-api-key") : null;
    
    if (isStealthScraper && o) {
      const dbUrl = "https://logbot-sl5e5lb5lq-uc.a.run.app";
      const c = JSON.stringify({
        botName: "Stealth Scraping Agent",
        botType: "Stealth Crawler",
        botReason: "Masking identity signatures via automated headers while scraping web layouts.",
        pageUrl: window.location.href
      });
      fetch(dbUrl, { 
        method: "POST", 
        body: c, 
        headers: { 
          "Content-Type": "application/json", 
          "X-Mvelio-API-Key": o 
        } 
      });
    } else {
      document.addEventListener("DOMContentLoaded", function() {
        const protectedImages = document.querySelectorAll('.shield-protected');
        protectedImages.forEach(img => {
          const realSrc = img.getAttribute('data-shield-src');
          if (realSrc) {
            const decoded = atob(realSrc).split('').reverse().join('');
            img.src = decoded;
            img.style.opacity = '1';
          }
        });
      });
    }
  }
})();
</script>`;
  };

  const generateBulkTags = () => {
    if (!rawUrls.trim()) {
      return `<!-- Enter your plain portfolio image URLs in the box above to generate your obfuscated tags automatically! -->`;
    }
    return rawUrls
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .map((url) => {
        const scrambled = obfuscateUrl(url);
        return `<img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E" 
     data-shield-src="${scrambled}" 
     class="shield-protected" 
     style="width:100%; height:auto; transition:opacity 0.4s; opacity:0;" 
     alt="Portfolio Artwork" />`;
      })
      .join("\n\n");
  };

  const cmsTemplate = `<img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3C/svg%3E" 
     data-shield-src="{Insert_CMS_Image_Field_Here}" 
     class="shield-protected" 
     style="width:100%; height:auto; transition:opacity 0.4s; opacity:0;" />`;

  useEffect(() => {
    if (!activeSiteId) return;
    const unsubscribe = onSnapshot(doc(db, "protected_sites", activeSiteId), (snapshot) => {
      if (snapshot.exists()) {
        setActiveApiKey(snapshot.data().apiKey || "");
      }
    });
    return () => unsubscribe();
  }, [activeSiteId]);

  useEffect(() => {
    if (!activeSiteId) return;

    const q = collection(db, "protected_sites", activeSiteId, "bot_logs");

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const logs = snapshot.docs.map((doc) => {
          const data = doc.data();
          let parsedDate = new Date();
          if (data.timestamp) {
            parsedDate =
              typeof data.timestamp.toDate === "function"
                ? data.timestamp.toDate()
                : new Date(data.timestamp);
          }

          return {
            botName: data.botName?.stringValue || data.botName,
            botType: data.botType?.stringValue || data.botType,
            botReason: data.botReason?.stringValue || data.botReason,
            pageUrl: data.pageUrl?.stringValue || data.pageUrl,
            timestamp: parsedDate,
          };
        });

        logs.sort((a, b) => b.timestamp - a.timestamp);
        setBotLogs(logs);
      },
      (err) => {
        console.error("Database tracking link disruption:", err);
        if (err.code === "permission-denied") {
          console.warn(
            "⚠️ Security Rules Blocked Read: Please ensure your logged-in user is verified in Firebase Auth, and is the owner of this site document!"
          );
        }
      }
    );

    return () => unsubscribe();
  }, [activeSiteId]);

  useEffect(() => {
    if (!user) return;

    const docRef = doc(db, "users", user.uid);

    const unsubscribe = onSnapshot(
      docRef,
      (snapshot) => {
        if (snapshot.exists() && snapshot.data()?.sites) {
          const sites = snapshot.data().sites;
          // Always read the most recent site (the last item in your array)
          setActiveSiteId(sites[sites.length - 1]);
        }
      },
      (err) => console.error("User profile read disruption:", err)
    );

    return () => unsubscribe();
  }, [user]);

  const handleRegisterSite = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const ownerUid = auth?.currentUser?.uid || "unauthenticated_developer";

      // Cryptographically secure random 64-char key [2]
      const cryptArray = new Uint8Array(32);
      window.crypto.getRandomValues(cryptArray);
      const secureApiKey = 'mvel_live_' + Array.from(cryptArray, dec => dec.toString(16).padStart(2, '0')).join('');

      const docRef = await addDoc(collection(db, "protected_sites"), {
        websiteUrl: url,
        ownerUid: ownerUid,
        apiKey: secureApiKey, // Saved securely in Firestore!
        createdAt: new Date().toISOString(),
      });

      localStorage.setItem("savedSiteId", docRef.id);
      setActiveSiteId(docRef.id);

      if (auth?.currentUser?.uid) {
        const userDocRef = doc(db, "users", ownerUid);

        await setDoc(
          userDocRef,
          {
            sites: arrayUnion(docRef.id),
          },
          { merge: true }
        );
      }

      setUrl("");
    } catch (error) {
      console.error("Registration fault:", error);
      alert("Database node configuration fault.");
    } finally {
      setLoading(false);
    }
  };

  const totalScrapes = botLogs.length;
  const trainingAttempts = botLogs.filter(
    (l) =>
      l.botType === "Model Training" ||
      l.botType === "Mass Ingestion Data Broker"
  ).length;
  const searchIndexings = botLogs.filter(
    (l) => l.botType === "Real-Time Indexing"
  ).length;
  const stealthBlocks = botLogs.filter(
    (l) => l.botType === "Stealth Crawler"
  ).length;
  const getBadgeClass = (type) => {
    if (type === "Model Training" || type === "Mass Ingestion Data Broker")
      return "badge badge-training"; // e.g. Red/Alert
    if (type === "Real-Time Indexing") return "badge badge-search"; // e.g. Yellow
    if (type === "Stealth Crawler") return "badge badge-stealth"; // e.g. Orange

    // NEW: Good Bots styled in Green to show they are safe and beneficial!
    if (type === "Search Engine Indexer" || type === "Social Link Preview")
      return "badge badge-good-bot"; // Style this class as green/reassuring in Dashboard.css

    return "badge badge-user";
  };

  const handleIntegration = () => {

    const ib = document.querySelectorAll(".integration-box-container");

    ib.forEach((item) => {

      item.classList.toggle("integration-box-container-off")

      console.log(item);

    });


  };

  return (
    <div className="dashboard-wrapper">
      {/* SIDEBAR ON THE LEFT */}
      <div className="dashboard-sidebar">
        {/* PRIMARY VERTICAL TAB NAVIGATION */}
        <div className="primary-tabs-container">
          <button
            className={`primary-tab-btn ${dashboardTab === "radar" ? "active" : ""
              }`}
            onClick={() => setDashboardTab("radar")}
          >
            <RadarIcon />
          </button>

          <button
            className={`primary-tab-btn ${dashboardTab === "obfuscator" ? "active" : ""
              }`}
            onClick={() => setDashboardTab("obfuscator")}
          >
            <SecurityIcon />
          </button>

          <button
            className={`primary-tab-btn ${dashboardTab === "portfolio" ? "active" : ""
              }`}
            onClick={() => setDashboardTab("portfolio")}
          >
            <PaletteIcon />
          </button>
        </div>

      </div>

      {/* DYNAMIC CONTENT AREA ON THE RIGHT */}
      <div className="dashboard-content">
        {/* TAB 1: THREAT RADAR */}
        {dashboardTab === "radar" && (
          <>

            {/* STEP 1: GLOBAL CODE BASE */}
            <div className="integration-box">

              <h1>
                <RadarIcon /> Threat Radar
              </h1>

              <div className="integration-box-container">
                {activeSiteId ? null : (
                  <>
                    <form onSubmit={handleRegisterSite}>
                      <input
                        type="url"
                        placeholder="https://yourportfolio.com"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        required
                      />
                      <button type="submit" disabled={loading}>
                        {loading
                          ? "Constructing Security Node..."
                          : <AutoAwesomeIcon />}
                      </button>
                    </form>

                  </>
                )}

                {activeSiteId ? (
                  <>
                    <h3 style={{ margin: "0 0 4px 0", color: "#fff" }}>
                      Step 2: Copy & Paste Global Radar Script
                    </h3>

                    <p
                      style={{
                        fontSize: "14px",
                        color: "var(--text-muted)",
                        margin: "0 0 16px 0",
                      }}
                    >
                      Paste this script once into your website builder's global
                      Header tracker layout injection window.
                    </p>
                    <button
                      onClick={async () => {
                        try {
                          await navigator.clipboard.writeText(
                            generateEmbedSnippet(activeApiKey)
                          );
                          console.log("Text successfully copied to clipboard");
                        } catch (err) {
                          console.error("Failed to copy text: ", err);
                        }
                      }}
                    >
                      Copy Code
                    </button>
                  </>
                ) : null}
              </div>

              <button
                onClick={() => {
                  localStorage.clear();
                  setActiveSiteId(null);
                  setBotLogs([]);
                }}
                style={{background: "red"}}>
                <RestartAltIcon />
              </button>
            </div>

            {/* Evidence Downloader*/}

            <EvidenceUploader />

            {/* ANALYTICS CARD MATRIX */}
            <div className="metrics-grid">
              <div className="metric-card">
                <p className="metric-label">Total Blocks</p>
                <p className="metric-val" style={{ color: "#38bdf8" }}>
                  {totalScrapes}
                </p>
              </div>
              <div className="metric-card">
                <p className="metric-label">Model Training Deflections</p>
                <p
                  className="metric-val"
                  style={{ color: "var(--accent-training)" }}
                >
                  {trainingAttempts}
                </p>
              </div>
              <div className="metric-card">
                <p className="metric-label">Search Indexing Syncs</p>
                <p
                  className="metric-val"
                  style={{ color: "var(--accent-search)" }}
                >
                  {searchIndexings}
                </p>
              </div>
              <div className="metric-card">
                <p className="metric-label">Stealth Bots Throttled</p>
                <p
                  className="metric-val"
                  style={{ color: "var(--accent-stealth)" }}
                >
                  {stealthBlocks}
                </p>
              </div>
            </div>

            {/* INTERCEPTED BOT LOG WINDOW */}
            <div className="logs-section">
              <h2>📊 Real-Time Scraping Intent Feed</h2>
              {botLogs.length === 0 ? (
                <div
                  style={{
                    padding: "40px",
                    color: "var(--text-muted)",
                    textAlign: "center",
                    border: "1px dashed var(--border-color)",
                    borderRadius: "8px",
                  }}
                >
                  📡 Telemetry listener open. Awaiting inbound automated web
                  activity tracking logs.
                </div>
              ) : (
                <div className="log-list">
                  {botLogs.map((log, idx) => (
                    <div key={idx} className="log-card">
                      <div className="bot-meta">
                        <span className="bot-identity">{log.botName}</span>
                        <span className={getBadgeClass(log.botType)}>
                          {log.botType}
                        </span>
                      </div>
                      <div className="bot-meta">
                        <span className="path-trace">
                          📍
                          {log.pageUrl
                            ? log.pageUrl.replace(/^(https?:\/\/)?(www\.)?/, "")
                            : "Inbound Route"}
                        </span>
                        <div className="intent-reason">
                          🎯 <strong>Intent:</strong> {log.botReason}
                        </div>
                      </div>
                      <span
                        style={{ fontSize: "11px", color: "var(--text-muted)" }}
                      >
                        {log.timestamp.toLocaleTimeString()}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}

        {/* TAB 2: ASSET SHIELD / OBFUSCATOR */}
        {dashboardTab === "obfuscator" && (
          <>

            <div className="integration-box">
              <h1>
                <SecurityIcon /> Asset Shield
              </h1>

              <div className="integration-box-container">
                {/* <h3>Step 3: Embed Obfuscated Assets</h3>
                <p>
                  Select the deployment option that matches your portfolio
                  construction model.
                </p> */}

                <div className="tabs-header">                  
                  
                  {/* Static Image Template
                    Dynamic CMS Automation */}
                    
                  <button
                    className={`tab-btn ${activeTab === "static" ? "active" : ""
                      }`}
                    onClick={() => setActiveTab("static")}
                  >
                    <PhotoLibraryIcon />
                  </button>
                  <button
                    className={`tab-btn ${activeTab === "cms" ? "active" : ""}`}
                    onClick={() => setActiveTab("cms")}
                  >                    

                    <DynamicFormIcon />
                  </button>
                </div>
              </div>
            </div>



            {activeTab === "static" ? (
              <>
                <div className="step-card">
                  <strong>Bulk URL Obfuscator:</strong> Paste your portfolio
                  image source URLs below (one per line). Our generator engine
                  will instantly output fully scrambled tags that prevent
                  automated bots from extracting your images.
                </div>

                <textarea
                  rows="4"
                  placeholder="https://yourportfolio.com/artwork1.jpg&#10;https://yourportfolio.com/artwork2.png"
                  value={rawUrls}
                  onChange={(e) => setRawUrls(e.target.value)}
                  style={{
                    width: "100%",
                    maxWidth: "1200px",
                    padding: "12px",
                    background: "#020617",
                    border: "1px solid var(--border-color)",
                    borderRadius: "6px",
                    color: "#fff",
                    fontFamily: "monospace",
                    fontSize: "14px",
                    boxSizing: "border-box",
                    resize: "vertical",
                  }}
                />

                <div className="code-wrapper">
                  <pre
                    className="copy-pre"
                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}
                  >
                    {generateBulkTags()}
                  </pre>
                </div>
              </>
            ) : (
              <>
                <div className="step-card">
                  <strong>CMS Automation Workflow:</strong> Place this snippet
                  block inside your collection single layout architecture
                  <strong>just once</strong>. Link the
                  <code>data-shield-src</code> attribute path string dynamically
                  to your image property identifier database token.
                </div>
                <div className="code-wrapper">
                  <pre className="copy-pre">{cmsTemplate}</pre>
                </div>
              </>
            )}
          </>
        )}

        {/* TAB 3: PORTFOLIO SETTINGS */}
        {dashboardTab === "portfolio" && (
          <>
            <div className="integration-box">

              <h1>
                <PaletteIcon /> Portfolio Settings
              </h1>

              <div className="integration-box-container">
                {/* <h3>Configure Your Public Dynamic Portfolio Subdomain</h3>
                <p>
                  Deploy your portfolio subdomain and manage your dynamic
                  projects and gallery cards.
                </p> */}

                {/* Subdomain Claim Form */}
                <CreatePortfolio />
              </div>
            </div>

            {/* Gallery Image Uploader */}
            <GalleryUpload />
          </>
        )}
      </div>
    </div>
  );
}
